import React, { useEffect, useRef } from "react";
import { VennDiagramChart, extractSets } from "chartjs-chart-venn";

function ChartVenn({ vennData, ...props }) {
    const canvasRef = useRef(null);
    const chartRef = useRef(null);

    useEffect(() => {
        if (chartRef.current) {
            chartRef.current.destroy();
        }

        const config = {
            type: "venn",
            data: extractSets(vennData?.data ? vennData?.data : [],
                {
                    label: vennData?.diagramLabel ? vennData?.diagramLabel : "",
                }
            ),
            options: {
                borderWidth: 1,
                backgroundColor: [
                    "rgba(255, 26, 104, 0.2)",
                    "rgba(54, 162, 235, 0.2)",
                    "rgba(255, 159, 64, 0.2)"
                ],
            }
        };

        chartRef.current = new VennDiagramChart(canvasRef.current, config);
        const canvas = canvasRef.current;
        canvas.style.maxWidth = '500px';
        canvas.style.maxHeight = '300px';
    }, [vennData]);

    return (

        <canvas
            ref={canvasRef}
            id="canvas"
            style={{
                maxWidth: 'inherit',
                maxHeight: '65vh',
                height: '50%',
                width: '50%',

            }}
        >
        </canvas>
    );
};

export default ChartVenn;
